module.exports = __webpack_public_path__ + "static/media/telefonia1.5972484e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flat/telefonia1.svg
// module id = 340
// module chunks = 0